/* eslint-disable max-len */
import { ERRORS } from '../constants';

export default {
  ERRORS: {
    [ERRORS.INVALID_PROZIS_POINTS]:
      'Ups, os ProzisPoints que querias partilhar com o estafeta já não estão disponíveis. Tenta novamente.'
  },
  MESSAGES: {
    ANSWERED_SURVEY:
      'Já tínhamos recebido o teu feedback em relação à entrega da encomenda {code}. \n\rFicamos à espera da tua opinião sobre a próxima experiência. 👍',
    AVAILABLE_POINTS: 'ProzisPoints disponíveis:',
    DO_NOT_SHARE_YOUR_POINTS: 'Não partilhar ProzisPoints',
    EXPERIENCE_EVALUATION: 'AVALIA A EXPERIÊNCIA DE ENTREGA',
    FEEDBACK_HERE: 'Deixa o teu feedback aqui',
    FEEDBACK_THANKS:
      'Obrigado pelo feedback sobre o serviço de entregas PROZIS NOW. \n\rPrometemos levá-lo a sério! 💪',
    HOW_BE_BETTER: 'Diz-nos o que estamos a fazer bem e onde podemos melhorar',
    MORE_TO_SAY: 'IMPROVE OURSELVES',
    SAY_HELP_TO_COURIER: 'Queres agradecer ao estafeta?',
    SAY_HELP_TO_USER: 'Queres agradecer a quem te entregou a encomenda?',
    SHARE_YOUR_POINTS:
      'Partilha os teus ProzisPoints com {name}. O teu gesto será apreciado. 😉',
    TIP_COURIER: 'Deixa uma gorjeta a {name}',
    TIP_USER: 'Deixa uma gratificação a {name}'
  }
};
